import { buildPrompt } from '@/ai/utils/promptBuilder'
import { examples } from '@/ai/prompts/common/examples'
import { systemMessages } from '@/ai/prompts/common/systemMessages'
import { createUserMessage, createSystemMessage } from '@/ai/utils/promptUtils'
import { getJsonArrayOutputFormatting, getJsonOutputFormatting } from '@/ai/prompts/common/formatting'

export const buildSortEventsPrompt = ({ events, stream }) => {
  const messages = []

  const systemMessage = buildPrompt([{ content: systemMessages.EVENT_MODELING_REVERSE_ENGINEERING }])
  messages.push(createSystemMessage(systemMessage))

  const promptSections = []

  promptSections.push({
    title: 'Unsorted Events',
    contentType: 'codeblock',
    language: 'json',
    content: JSON.stringify(events)
  })

  promptSections.push({
    title: 'Request: Sort Events Chronologically',
    content: [
      'Your task is to take the list of domain events provided above and arrange them in a logical, **business\u2011relevant chronological order**.',
      'Use your understanding of typical domain flows to infer which events should occur first, next, and last.',
      'For example, "User Created" should come before "User Updated," and "Order Placed" should come before "Payment Completed."',
      'Do **not** add, remove, or rename any events; only change their order.',
      'If multiple events appear unrelated, group them in a sequence that makes sense from a high-level business perspective (e.g., user onboarding before billing, messaging components after account creation).'
    ]
  })

  promptSections.push({
    title: 'Note',
    contentType: 'bullet',
    content: [
      'Maintain each event\'s "role" and "description" exactly as provided—do **not** modify them.',
      'Focus solely on reordering to reflect a coherent workflow. If two events could happen in parallel, place them adjacent without implying a strict time gap.',
      'If you are unsure about the exact sequence, choose the most reasonable assumption based on common domain patterns.'
    ]
  })

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: stream
      ? getJsonArrayOutputFormatting(JSON.stringify(examples.workflowDiagram))
      : getJsonOutputFormatting('events', JSON.stringify({ events: examples.workflowDiagram }))
  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
